function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { alpha } from '@mui/material/styles';
import customThemeColors from "./custom-theme-colors";
import theme from "../../themes";

/**
 * Generate custom theme overrides from custom colors array
 *
 * @param {number} selectedIndex
 * @returns {object} - Overrides object to merge with MUI & Sovos themes
 */
var generateCustomTheme = function generateCustomTheme() {
  var colorThemes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : customThemeColors;
  var logoAlt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var logoUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var selectedIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  if (selectedIndex === 0) {
    return {
      overrides: {
        sovosNavigation: _objectSpread({
          logoAlt: logoAlt,
          logoUrl: logoUrl
        }, theme.overrides.sovosNavigation)
      }
    };
  }
  return {
    overrides: {
      sovosNavigation: {
        logoAlt: logoAlt,
        logoUrl: logoUrl,
        highlights: colorThemes[selectedIndex].colors.highlights,
        headerBackground: colorThemes[selectedIndex].colors.background,
        gradientTop: colorThemes[selectedIndex].colors.background,
        gradientBottom: colorThemes[selectedIndex].colors.background,
        footerBackground: colorThemes[selectedIndex].colors.background,
        navItemForeground: colorThemes[selectedIndex].colors.text,
        navItemHover: alpha(colorThemes[selectedIndex].colors.hover, 0.5),
        productNameColor: colorThemes[selectedIndex].colors.highlights
      }
    }
  };
};
export default generateCustomTheme;